import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  EffectCoverflow,
  Autoplay,
} from "swiper/modules";
import "swiper/css";
import { Link } from "react-router-dom";
import HeroSlider from "./Hero";

import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectFade } from "swiper/modules";
import VideoPlay from "./VideoPlay";
import About from "./About";
import Gallery from "./mainLayout/Gallery";
import Blog from "./mainLayout/Blog";
import Footer from "./mainLayout/Footer";
import Contact from "./mainLayout/Contact";
import Elements from "./mainLayout/Elements";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Branding from "./Branding";
import Section3 from "./Section3";
import Canvas from "./Canvas";


const MainLayout = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
 
  return (
    <div>
      <HeroSlider />
<Section1/>
      <About/>
<Section2/>
      <Section3/>

      <Gallery/>
      {/* <Canvas/> */}
      <Contact/>

      <Branding/>
      <Blog/>

      {/* <Footer/> */}
      {/* <Elements/> */}

    
     
    </div>
  );
};

export default MainLayout;
